import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 公共接口
// Vue.prototype.beseAjax = 'https://m.yixueyijia.com/school_wap/';
// Vue.prototype.beseSend = 'https://open.yixueyijia.com';


Vue.prototype.beseAjax = 'https://m.yixueyijia.com/school_wap/';
Vue.prototype.beseSend = 'https://open.yixueyijia.com';

Vue.config.productionTip = false;


//vant组件
import { Grid, GridItem, Swipe, SwipeItem, Image as VanImage, Col, Row, Lazyload, Collapse, CollapseItem, Toast } from 'vant';
import 'vant/lib/index.css';
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Lazyload);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Toast);
// 轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )

//刷新进入页面top为0
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
    window.pageYOffset = 0
    next()
});


Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");